import queryString from 'query-string'
import history from '@src/router/history'

export const getRedirectUriObject = () => {
  const locationSearch = history.location.search
  const locationSearchParams = queryString.parse(locationSearch)
  const redirectUri = locationSearchParams?.redirect_uri
  const redirectUriQueryString = redirectUri && `?redirect_uri=${encodeURIComponent(redirectUri)}`

  return {
    redirectUri,
    redirectUriQueryString
  }
}

export const goTo2FAPage = (username, to, method, expiredAfter, id) => {
  history.push({
    pathname: `2fa/${username}/`,
    search: `?to=${to}&method=${method}&expiredAfter=${expiredAfter}&id=${id}`,
    state: {fromAutoLogin: true}
  })
}
